/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import { getContentFromContentStack } from "../../../core/contentStack";

// Interface for GreetingComponent Props
interface GreetingComponentProps {
  userName: string;
  guest_message: string;
  login_message: string;
  isAuthenticated: boolean;
  handleSuccessfulContinue: any;
}
// Interface for GreetingComponent State
interface GreetingComponentState {
  userName: string;
  isEmptyName: boolean;
  isAuthenticated: boolean;
  result: any;
  error: any;
}

/**
 * Greeting component
 *
 * @namespace GreetingComponent
 */
class GreetingComponent extends React.Component<
  GreetingComponentProps,
  GreetingComponentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      userName: "",
      isEmptyName: false,
      isAuthenticated: false,
      result: [],
      error: {},
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.props.handleSuccessfulContinue();
    }, 3000);
  };

  render() {
    const { result } = this.state;
    const { guest_message, login_message, userName, isAuthenticated } = this.props;
    return (
      // <div className="main-area">
      <div className="greeting-container">
        <div className="inner-wrapper">
          <div className="bg-image-wrapper">
            <span className="image"></span>
          </div>
          <div className="name-input-wrapper">
            <div className="question-label">
              {!isAuthenticated ? guest_message.replace("$Name", userName) : login_message.replace("$Name", userName)}
              <div className="question-label"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GreetingComponent;
